import { Editor, Node, Path, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';

export function canInsertAt(editor, path) {
  return path !== null && path.length === 1 && Node.has(editor, path);
}

export function insert(editor, path, options = {}) {
  if (!canInsertAt(editor, path)) {
    return null;
  }
  let target = path;
  HistoryEditor.withNewBatch(editor, function insertHeader() {
    Editor.withoutNormalizing(editor, function placeHeader() {
      const node = Node.get(editor, path);
      if (node.type === 'paragraph' && Editor.isEmpty(editor, node)) {
        Transforms.removeNodes(editor, { at: path });
      } else {
        target = Path.next(path);
      }
      Transforms.insertNodes(editor, serializer.utilities.node.siteNav.buildStarterNode(options), { at: target });
      Transforms.select(editor, Editor.start(editor, target));
    });
  });
  return target;
}
